import { createSlice }      from '@reduxjs/toolkit';
import * as invoiceReducers from 'Redux/Reducers/Invoice';
import { Invoice }         from 'Domain/Models';

export interface IInvoiceState {
  openRequests: string[],
  failedRequests: string[],
  updatedAt: number,
  entries: Record<string, Invoice>,
  lastUpdateId: string | null,
  maxCount: number,
}

export const invoiceSlice = createSlice({
  name: 'invoice',
  initialState: {
    openRequests: [],
    failedRequests: [],
    entries: {},
    maxCount: 0,
    lastUpdateId: null,
    updatedAt: 0,
  },
  reducers: invoiceReducers,
});
